function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { coinSvg } from "../../svg";
import Select from "react-select";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var configurationTypes = [{
  type: "1 RK",
  value: "1RK"
}, {
  type: "1 BHK",
  value: "1BHK"
}, {
  type: "1.5 BHK",
  value: "1.5BHK"
}, {
  type: "2 BHK",
  value: "2BHK"
}, {
  type: "2.5 BHK",
  value: "2.5BHK"
}, {
  type: "3 BHK",
  value: "3BHK"
}, {
  type: "3.5 BHK",
  value: "3.5BHK"
}, {
  type: "4 BHK",
  value: "4BHK"
}, {
  type: "4.5 BHK",
  value: "4.5BHK"
}, {
  type: "5 BHK",
  value: "5BHK"
}, {
  type: "Villa",
  value: "Villa"
}, {
  type: "Other",
  value: "Other"
}];
var StepOne = function StepOne(_ref) {
  var setStep = _ref.setStep,
    unitConfig = _ref.unitConfig,
    handleunitConfigChange = _ref.handleunitConfigChange,
    prefilledData = _ref.prefilledData,
    prefilledUnitConfig = _ref.prefilledUnitConfig,
    prefilledUnitArea = _ref.prefilledUnitArea,
    handleChange = _ref.handleChange,
    unitArea = _ref.unitArea,
    error = _ref.error;
  var getDropdownOptions = function getDropdownOptions() {
    if (prefilledData.length > 1) {
      return prefilledData.map(function (data) {
        return {
          label: data === null || data === void 0 ? void 0 : data.unitConfiguration,
          value: data === null || data === void 0 ? void 0 : data.unitConfiguration
        };
      });
    }
    return configurationTypes.map(function (config) {
      return {
        label: config.type,
        value: config.value
      };
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex text-base md:text-lg font-semibold justify-between py-3 ",
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex items-center gap-1",
        children: /*#__PURE__*/_jsx("button", {
          className: "font-semibold",
          children: "Enquiry"
        })
      }), /*#__PURE__*/_jsxs("p", {
        children: ["Step ", /*#__PURE__*/_jsx("span", {
          className: "text-primary text-sm md:text-base",
          children: "1"
        }), /*#__PURE__*/_jsx("span", {
          className: " text-xs md:text-sm",
          children: "/2"
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex items-center border rounded-[10px] p-5 ",
      children: [/*#__PURE__*/_jsx("div", {
        children: coinSvg
      }), /*#__PURE__*/_jsxs("div", {
        className: "text-left pl-3",
        children: [/*#__PURE__*/_jsx("h1", {
          className: "font-bold leading-[1] text-sm md:text-base whitespace-nowrap ",
          children: "Thank you for your enquiry"
        }), /*#__PURE__*/_jsx("p", {
          className: " text-xs md:text-sm text-[#adadad] mt-1",
          children: "Please share a few more details to help serve you better"
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col gap-4",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "mb-2 grid grid-cols-1 mt-2 gap-x-7",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "mt-4",
            children: [/*#__PURE__*/_jsx("h2", {
              className: "font-semibold text-left",
              children: "Unit Configuration"
            }), /*#__PURE__*/_jsx("div", {
              className: "h-12 lg:h-10 xl:h-[50px]",
              children: /*#__PURE__*/_jsx(Select, {
                placeholder: "Select configuration",
                options: getDropdownOptions(),
                onChange: function onChange(val) {
                  handleunitConfigChange(val);
                },
                value: prefilledUnitConfig ? {
                  value: prefilledUnitConfig,
                  label: prefilledUnitConfig
                } : unitConfig ? {
                  value: unitConfig === null || unitConfig === void 0 ? void 0 : unitConfig.Name,
                  label: unitConfig === null || unitConfig === void 0 ? void 0 : unitConfig.displayName
                } : null,
                isDisabled: prefilledData.length === 1 && prefilledUnitConfig,
                styles: {
                  container: function container(provided, state) {
                    return _objectSpread(_objectSpread({}, provided), {}, {
                      width: "100%",
                      color: "black",
                      height: "100%"
                    });
                  },
                  control: function control(styles, state) {
                    return _objectSpread(_objectSpread({}, styles), {}, {
                      opacity: "0.95",
                      height: "100%",
                      color: "black",
                      boxShadow: "none"
                    });
                  },
                  placeholder: function placeholder(styles) {
                    return _objectSpread(_objectSpread({}, styles), {}, {
                      color: "#adadad",
                      fontFamily: "inherit",
                      fontWeight: 400
                    });
                  }
                },
                className: "text-[#adadad] placeholder-[#adadad] font-semibold bg-white text-base text-left rounded-[8px] mt-2  "
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "mt-4",
            children: [/*#__PURE__*/_jsx("h2", {
              className: "font-semibold text-left",
              children: "Unit Area (sq. ft)"
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("input", {
                className: "outline-none text-left border rounded-[8px] p-3 mt-2 w-full",
                type: "text",
                placeholder: "Unit Area",
                value: unitArea,
                onChange: handleChange,
                disabled: prefilledData.length === 1 && prefilledUnitArea
              }), error && /*#__PURE__*/_jsx("p", {
                className: "text-red-500 mt-1",
                children: error
              })]
            })]
          })]
        }), /*#__PURE__*/_jsx("button", {
          className: "w-full text-white p-3 rounded-[10px] disabled:cursor-not-allowed disabled:bg-[#adadad] bg-primary",
          onClick: function onClick() {
            return setStep(function (prev) {
              return prev + 1;
            });
          },
          children: "Continue"
        })]
      })
    })]
  });
};
export default StepOne;